import { useAlert, AlertType } from '../context/AlertContext'

const TOAST_CONFIG: Record<AlertType, { classes: string; icon: string }> = {
  success:   { classes: 'bg-success-light text-success-emphasis',     icon: 'bi-check-circle' },
  danger:    { classes: 'bg-danger-light text-danger-emphasis',       icon: 'bi-x-circle' },
  warning:   { classes: 'bg-warning-light text-warning-emphasis',     icon: 'bi-exclamation-circle' },
  info:      { classes: 'bg-info-light text-info-emphasis',           icon: 'bi-info-circle' },
  primary:   { classes: 'bg-primary-light text-primary-emphasis',     icon: 'bi-bell' },
  secondary: { classes: 'bg-secondary-light text-secondary-emphasis', icon: 'bi-bell' },
  light:     { classes: 'bg-light text-dark',                         icon: 'bi-bell' },
  dark:      { classes: 'bg-dark-light text-dark',                    icon: 'bi-bell' },
}

export default function Alert() {
  const { alerts, hideAlert } = useAlert()

  return (
    <div className="toast-container position-fixed top-0 end-0 p-3" style={{ zIndex: 1055 }}>
      {alerts.map((alert) => {
        const { classes, icon } = TOAST_CONFIG[alert.type]
        return (
          <div
            key={alert.id}
            className={`toast show align-items-center ${classes} border-0 mb-2`}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="d-flex">
              <div className="toast-body">
                <i className={`bi ${icon} me-2`}></i>
                {alert.title && <strong className="me-1">{alert.title}</strong>}
                {alert.message}
              </div>
              {alert.closable && (
                <button
                  type="button"
                  className="btn-close me-2 m-auto"
                  onClick={() => hideAlert(alert.id)}
                  aria-label="Close"
                />
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
